<template>
    <div style="height:100%;width:100%;display:flex;flex-direction:row;overflow-y: scroll;position: relative;">
        <section class="w-100">
            <waitingBlock v-if="viewState.isLoading"></waitingBlock>
            <div v-else>
                <div class="caption">
                    <a class="refresh" href="#" v-on:click.prevent="loadStats(true)" style="margin-right: -30px;"><i class="fas fa-sync"/></a>
                    Last update : {{ moment(stats.lastUpdate) }} </div>
                <div class="highlights nowrap">
                    <div    
                        class="highlight"
                        v-for="(highlight, index) in firstLevel"
                        :key="index"
                        :class="highlight.size">
                        <h1>{{ highlight.label }}</h1>
                        <div class="count">{{ highlight.count }}</div>
                    </div>
                </div>
                <div class="highlights nowrap">
                    <div
                            class="highlight"
                            v-for="(highlight, index) in secondLevel"
                            :key="index"
                            :class="highlight.size">
                        <h1>{{ highlight.label }}</h1>
                        <div class="count" v-if="!highlight.date">{{ highlight.count }}</div>
                        <div class="count" v-else>{{ moment(highlight.date).format('DD/MM/YYYY') }}</div>
                        <div v-if="highlight.label === 'Next content update'"><span class="count">{{highlights.gauge.newSongsCount}}</span> (files)</div>
                        <div v-if="highlight.label === 'Next content update' && highlights.gauge.loading " style="width: 170px ; height: 170px ;margin-left: 15%;margin-right: 10%;">
                        <vue-speedometer style=""
                            :width="320"
                            :height="300"
                            :needleHeightRatio="0.7"
                            :value="highlights.gauge.totalSizeMbCalcul"
                            :segments="3"
                            :customSegmentStops="[0, 500, 750, 1000]"
                            :customSegmentLabels='[
                              {
                                text: "Good",
                                position: "OUTSIDE",
                                color: "limegreen",
                              },
                              {
                                text: "Warning",
                                position: "OUTSIDE",
                                color: "gold",
                              },
                              {
                                text: "Too much",
                                position: "OUTSIDE",
                                color: "red",
                              },
                            ]'
                            :segmentColors='["limegreen",  "gold", "red"]'
                            :ringWidth="47"
                            :needleTransitionDuration="3333"
                            needleTransition="easeElastic"
                            needleColor="#000000"
                            textColor="#000000"
                            :currentValueText="` `+ highlights.gauge.totalSizeMb +` MB`"
                            labelFontSize="15px"
                            valueTextFontSize="20px"
                        />

                      </div>
                    </div>
                </div>

                <div class="graphs">
                    <SemiCirclePieChart
                            :initial-data="stats.byType"
                            :fields="{value: 'ratio', category: 'name', max: 'maxPercentage'}">
                        <template v-slot:title>Total track per type</template>
                        <template v-slot:label="{ colors, index, record, othersData }">
                            <span class="d-flex align-items-center"><span class="label-color mr-2" :style="`background-color: ${colors[index]};`"></span> {{ record['name'] }}</span>
                            <div class="label-value">
                                <span class="font-weight-bold">{{ record.count }} ·</span>
                                <span class="d-inline-block text-right" style="width: 40px;">{{ Math.round(record.ratio * 100) / 100 }}%</span>
                            </div>
                        </template>
                    </SemiCirclePieChart>
                    <Lines
                        :initial-data="stats.byStyle"
                        :fields="{value: 'ratio', category: 'name', max: 'maxPercentage'}"
                        :numeric-fields="['count', 'ratio']">
                        <template v-slot:title>Genres</template>
                        <template v-slot:label:value="{ colors, index, record, othersData }">
                            <div class="label-value">
                                <span class="font-weight-bold">{{ record.count }}</span>
                            </div>
                        </template>
                    </Lines>
                    <SemiCirclePieChart
                        :initial-data="stats.byGender"
                        :fields="{value: 'count', category: 'name', ratio: 'ratio'}">
                        <template v-slot:title>Gender</template>
                        <template v-slot:label="{ colors, index, record, othersData }">
                            <span class="d-flex align-items-center"><span class="label-color mr-2" :style="`background-color: ${colors[index]};`"></span> {{ record['name'] }}</span>
                            <div class="label-value">
                                <span class="font-weight-bold">{{ record.count }} ·</span>
                                <span class="d-inline-block text-right" style="width: 40px;">{{ Math.round(record.ratio * 100) / 100 }}%</span>
                            </div>
                        </template>
                    </SemiCirclePieChart>
                    <RadarChart
                        :initial-data="stats.byLanguage"
                        :fields="{value: 'count', category: 'name', ratio: 'ratio'}">
                        <template v-slot:title>Languages</template>
                    </RadarChart>
                    <SemiCirclePieChart
                        :initial-data="filteredStats(stats.byMood, 'mood')"
                        :fields="{value: 'count', category: 'name', ratio: 'ratio'}"
                        :tooltip="(data) => { return `<i class='${Constants.moods[data.category].icon}' /> <span class='font-weight-bold'>${data.value}</span>`; }"
                        :is-sort-desc="false"
                        type="mood">
                        <template v-slot:title>Moods</template>
                        

                        <template v-slot:label="{ colors, index, record, othersData }">
                            <template v-if="Constants.moods[record['name']]!==undefined">
                                <span class="d-flex align-items-center">
                                <span class="label-color mr-2" :style="`background-color: ${colors[index]};`"></span>
                                <i :class="(Constants.moods[record['name']] ||{}).icon" />
                                </span>
                                <div class="label-value">
                                    <span class="font-weight-bold">{{ record.count }} ·</span>
                                    <span class="d-inline-block text-right" style="width: 40px;">{{ Math.round(record.ratio * 100) / 100 }}%</span>
                                </div>
                            </template>
                        </template>
                    </SemiCirclePieChart>
                    <Lines
                            :initial-data="stats.byYear"
                            :fields="{value: 'ratio', category: 'name', max: 'maxPercentage'}"
                            :numeric-fields="['count', 'ratio']"
                            type="rangeFrom">
                        <template v-slot:title>Years</template>
                        <template v-slot:label:value="{ colors, index, record, othersData }">
                            <div class="label-value">
                                <span class="font-weight-bold">{{ record.count }}</span>
                            </div>
                        </template>
                    </Lines>
                    <SemiCirclePieChart
                            :initial-data="filteredStats(stats.byEnergy, 'energy')"
                            :fields="{value: 'count', category: 'energy', ratio: 'ratio'}"
                            :tooltip="(data) => { return `<i class='${Constants.energies[data.category].icon}' /> <span class='font-weight-bold'>${data.value}</span>`; }"
                            :is-sort-desc="false"
                            type="energy">
                        <template v-slot:title>Energy</template>
                        <template v-slot:label="{ colors, index, record, othersData }">
                            <span class="d-flex align-items-center">
                              <span class="label-color mr-2" :style="`background-color: ${colors[index]};`"></span>
                              <i :class="Constants.energies[record.energy].icon" />
                            </span>
                            <div class="label-value">
                                <span class="font-weight-bold">{{ record.count }} ·</span>
                                <span class="d-inline-block text-right" style="width: 40px;">{{ Math.round(record.ratio * 100) / 100 }}%</span>
                            </div>
                        </template>
                    </SemiCirclePieChart>
                    <Lines
                            :initial-data="stats.byBpm"
                            :fields="{value: 'ratio', category: 'name', max: 'maxPercentage'}"
                            :numeric-fields="['count', 'ratio']"
                            type="rangeFrom">
                        <template v-slot:title>BPM</template>
                        <template v-slot:label:value="{ colors, index, record, othersData }">
                            <div class="label-value">
                                <span class="font-weight-bold">{{ record.count }}</span>
                            </div>
                        </template>
                    </Lines>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { HTTP } from "@/utils/http"
import moment from "moment"
import Apis from "@/apis/index"
import Constants from '@/store/constants'
import Translations from '@/store/translations'
import { minutesToDuration } from "@/lib/formatting"

import WaitingBlock from "@/components/common/WaitingBlock"
import Lines from "@/components/common/stats/Lines"
import DonutChart from "@/components/common/stats/DonutChart"
import PieChart from "@/components/common/stats/PieChart"
import RadarChart from "@/components/common/stats/RadarChart"
import SemiCirclePieChart from "@/components/common/stats/SemiCirclePieChart"
import SolidGaugeChart from "@/components/common/stats/SolidGaugeChart"
import {mapActions, mapState} from "vuex";
import {safeObj} from "@/utils/safeObj";
import Moment from 'moment';
import VueSpeedometer from "vue-speedometer"

export default {
  name: 'Dashboard',

  components: {
    WaitingBlock,
    Lines,
    DonutChart,
    PieChart,
    RadarChart,
    SemiCirclePieChart,
    SolidGaugeChart,
    VueSpeedometer
  },

  data() {
    return {
      moment,
      Constants,
      languages: [],
      stats: {},
      viewState: {
        isLoading: false
      },
      typeId: {
        1: "Music tracks",
        2: "Jingle",
        5: "Podcast"
      }
    }
  },

  computed: {
    ...mapState(["currentStation"]),
    highlights() {
      return {
        trackCount: {label: "Tracks", count: 0, size: null},
        podcastCount: {label: "Podcast", count: 0, size: null},
        advertCount: {label: "Jingle", count: 0, size: null},
        nextEmptyDay: {label: "Next Day without Planning", date: null, size: 'large'},
        gauge: {label: "Next content update", count: null, size: null, newSongsCount: 0, totalSizeMb: 0 , loading:false},
        tracksInLastMonth: {label: "Files added in the last 30d", count: 0, size: 'large'}
      }
    },
    firstLevel() {
      return [
        this.highlights.trackCount,
        this.highlights.podcastCount,
        this.highlights.advertCount
      ]
    },
    secondLevel() {
      return [
        this.highlights.nextEmptyDay,
        this.highlights.gauge,
        this.highlights.tracksInLastMonth
      ]
    }
  },

  mounted() {
    this.loadGaugeData();
    this.loadLanguages()
    this.loadStats();
   // this.isStationLock(this.$route.params.stationUid);
  },

  methods: {
    ...mapActions('tracks', ['isStationLock']),
    filteredStats(array, key) {
      return array && array.filter(e => e[key] !== 0)
    },
    formatStats(data) {

      Object.keys(data).map(key => {
        if (!data[key]) return false;
        if (data[key].length === 0) {
          return false
        }

        if (key === 'byLanguage') {
          data[key].map(record => {
            const language = this.languages.find(language => language.code === record.code)

            record.name = language ? language.name : record.code

            return record
          })
        }

        if (key === 'byGender') {
          data[key].map(record => {
            record.name = Translations.genders[record.name] || record.name

            return record
          })
        }

        if (key === 'byType') {
          data[key].map(record => {
            record.name = Translations.trackTypes[record.name] || record.name

            return record
          })
          // Hide Voice Tracks & Undefined types
          data[key] = data[key].filter(record => {
            let recordType = Object.values(Constants.trackTypes).find(type => type.value === record.typeId)

            return !['UNDEFINED', 'VOICE_TRACK', 'PROMO', 'FILLER'].includes(recordType.key)
          })
        }

        if (key === 'byMood') {
          data[key].map(record => {
            record.name = Translations.moods[record.mood] || record.mood

            return record
          })
        }

        if (key === 'byEnergy') {
          data[key].map(record => {
            record.name = Object.values(Translations.energies)[record.energy] || record.energy

            return record
          })
        }

        if (key === 'byYear') {
          data[key].map(record => {
            record.name = record.rangeFrom + '\'s'

            return record
          })
        }

        if (key === 'byBpm') {
          data[key].map(record => {
            record.name = record.rangeFrom + ' - ' + record.rangeTo;

            return record
          })
        }
        // add this property to each type with an array
        if (Array.isArray(data[key])) {
          return data[key].map(record => record.maxPercentage = 100)
        }
      })

      return data
    },

    getInfosFromType(data, typeId) {
      return data.byType.filter(type => type.typeId === typeId)[0];
    },

    handleStatistics(data) {
      console.log("handleStatistics 1")
      this.stats = this.formatStats(data || {})
      this.highlights.tracksInLastMonth.count = data.last30DaysTracks;
      this.highlights.nextEmptyDay.date = data.nextDayWithoutPlanning;
      this.highlights.trackCount.count = this.getInfosFromType(data, 1).count;
      this.highlights.advertCount.count = this.getInfosFromType(data, 2).count;
      this.highlights.podcastCount.count = this.getInfosFromType(data, 5).count;
      console.log("handleStatistics 2")
    },

    async loadLanguages() {
      await HTTP.get(Apis.parameters.languages)
          .then(({data}) => {
            this.languages = data.dataItem
          })
    },
    async loadGaugeData() {
      this.highlights.gauge.loading = false;
      HTTP.get(Apis.station.contentUpdate, {
        params: {
          stationUid: this.$route.params.stationUid,
        }
      })
          .then(({data}) => {
            this.highlights.gauge = data.dataItem;
            console.log(this.highlights.gauge)
            this.updateDataGauge();
          })

    },
    updateDataGauge() {

      if (this.highlights.gauge.totalSizeMb >= 0 && this.highlights.gauge.totalSizeMb < 500) {
        this.highlights.gauge.totalSizeMbCalcul = this.highlights.gauge.totalSizeMb;
      }
      if (this.highlights.gauge.totalSizeMb >= 500 && this.highlights.gauge.totalSizeMb < 600) {
        this.highlights.gauge.totalSizeMbCalcul = ((this.highlights.gauge.totalSizeMb - 500) * 2.5) + 500;
      }
      if (this.highlights.gauge.totalSizeMb >= 600 && this.highlights.gauge.totalSizeMb < 700) {
        this.highlights.gauge.totalSizeMbCalcul = 750 + (250 / (100 / (this.highlights.gauge.totalSizeMb - 600)));
      }
      if (this.highlights.gauge.totalSizeMb >= 700) {
        this.highlights.gauge.totalSizeMbCalcul = 1000
      }
      this.highlights.gauge.loading = true;
      this.$forceUpdate();
    },
    async loadStats(refresh) {
      this.viewState.isLoading = true
      //this.stats = {}

      await HTTP.get(Apis.station.dashboard, {
        params: {
          stationUid: this.$route.params.stationUid,
          refresh: (refresh || false)
        }
      })
          .then((response) => {
            this.viewState.isLoading = false
            this.handleStatistics(response.data.dataItem || {})
          }, (error) => {
            console.log('error', error)
          })
          .then(() => {
            this.viewState.isLoading = false
          })
    },

    minutesToDuration
  },

  watch: {
    '$route.params.stationUid': function (value) {
      this.loadGaugeData();
      this.loadStats();
     // this.isStationLock(this.$route.params.stationUid);

    },
    currentStation: function () {
      console.log("station loaded");
    },

  }
}
</script>

<style lang="scss" scoped>
div.caption{
    text-align: right;
    font-size: 12px;
    font-weight: 600;
}
.graph-container {
  width: calc(50% - 5px);
  margin-top: 20px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;

  header {
    color: #292c33;
    border-bottom: 1px solid var(--COLOR_BORDERS);
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.2px;
    line-height: 20px;
  }
  .graph {
    min-height: 275px;
  }
}

@media (max-width: 1200px) {
  .graph-container {
    width: 100%;
  }
}
.highlights {
  display: flex;
  flex-wrap: wrap;
  color: #292c33;
  background-color: #e1e0e1;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  &.nowrap{
      flex-wrap: nowrap;
      justify-content: space-between;
      width: 100%;
      .highlight{
          flex: 0 0 33.20%;
          //width: 33.33%;
      }
  }
}

.highlights .highlight {
  //width: calc(25%  - 2px);
  padding: 20px;
  background: white;
  margin: 1px;

  &.large {
    width: calc(50% - 2px);
  }
}

@media (max-width: 1200px) {
  .highlights .highlight {
    width: calc(50% - 2px);
  }
}

.highlight h1 {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 20px;
}

.highlight div.count {
  margin-top: 15px;
  font-size: 40px;
  font-weight: bold;
  line-height: 49px;
}
.highlight span.count {
  margin-top: 15px;
  font-size: 40px;
  font-weight: bold;
  line-height: 49px;
}
.graphs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 10px;
}
</style>
